import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, Optional, inject } from '@angular/core';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { BodyClassService } from '@df/ui/body-class.service';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { ModalLayoutRightComponent, NModalLayoutRight } from '../../../ui/modal/modal-layout-right.component';
export const PROTECTION_PLAN_INFO_MODAL_ID = 'protectionPlanInfoModal';
@DfModal({
    id: PROTECTION_PLAN_INFO_MODAL_ID,
    position: 'right',
    config: sizeName => ({
        ...NModalLayoutRight.ModalConfig,
        width: NModalLayoutRight.getWidth(sizeName)
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@Component({
    selector: 'protection-plans-info-modal',
    templateUrl: './protection-plans-info-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ModalLayoutRightComponent, CommonModule, SizeClassDirective, OptionLabelPipe]
})
export class ProtectionPlansInfoModalComponent implements OnInit, OnDestroy {
    constructor(
        @Optional()
        private modalRef: ModalRef<ProtectionPlansInfoModalComponent>,
        @Optional()
        @Inject(MODAL_DATA)
        public product: Product<IProductDataV3>
    ) {}
    private bodyClassService = inject(BodyClassService);

    private readonly bodyClassName = 'protection-plans-info-modal-open';

    ngOnInit() {
        this.bodyClassService.add(this.bodyClassName, this);
    }

    ngOnDestroy() {
        this.bodyClassService.remove(this.bodyClassName, this);
    }

    close() {
        this.modalRef.close();
    }
}
